<template>
  <div class="content-top idm-player" id="content_top">
    <div class="form-block">
      <form>
        <div class="form">
          <div class="input" :class="{'required-error':!apiCallData.text_opening.valid.required, 'limit-error':!apiCallData.text_opening.valid.limit}">
            <div class="input-label">
              <span class="label">Fundraiser title</span>
              <div class="validation-required">(Required)</div>
            </div>
            <div class="input-wrap">
              <input type="text" v-model="apiCallData.text_opening.value" @keyup="validate">
              <span class="validation-limit">You've passed the character limit</span>
            </div>
          </div>

          <div class="input" :class="{'required-error':!apiCallData.text_description.valid.required, 'limit-error':!apiCallData.text_description.valid.limit}">
            <div class="input-label">
              <span class="label">Short description of fundraiser or Custom Message</span>
              <div class="validation-required">(Required)</div>
            </div>
            <div class="input-wrap">
              <input type="text" v-model="apiCallData.text_description.value" @keyup="validate">
              <span class="validation-limit">You've passed the character limit</span>
            </div>
          </div>

          <div class="input" :class="{'required-error':!apiCallData.dollars_to_goal.valid.required}">
            <div class="input-label">
              <span class="label">Amount to Goal</span>
              <div class="validation-required">(Required)</div>
            </div>
            <div class="input-wrap">
              <input type="text" v-model="apiCallData.dollars_to_goal.value" @keyup="validate">
            </div>
          </div>

          <div class="input" :class="{'required-error':!apiCallData.percent_to_goal.valid.required}">
            <div class="input-label">
              <span class="label">Percentage to fundraising goal</span>
              <div class="validation-required">(Required)</div>
            </div>
            <div class="input-wrap">
              <input type="text" v-model="apiCallData.percent_to_goal.value" @keyup="validate">
            </div>
          </div>

          <div class="input" :class="{'required-error':!apiCallData.gfm_URL.valid.required}">
            <div class="input-label">
              <span class="label">fundraiser URL</span>
              <div class="validation-required">(Required)</div>
            </div>
            <div class="input-wrap">
              <input type="url" v-model="apiCallData.gfm_URL.value" @keyup="validate">
            </div>
          </div>

          <div class="input" :class="{'required-error':!apiCallData.Category.valid.required}">
            <div class="input-label">
              <span class="label">Category</span>
              <div class="validation-required">(Required)</div>
            </div>
            <div class="input-wrap">
              <select v-model="apiCallData.Category.value" @change="validate">
                <option value="" disabled style="display:none">- Select -</option>
                <option value="animal">animal</option>
                <option value="business">business</option>
                <option value="charity">charity</option>
                <option value="education">education</option>
                <option value="emergency">emergency</option>
                <option value="faith">faith</option>
                <option value="medical">medical</option>
                <option value="memorial">memorial</option>
                <option value="sports">sports</option>
              </select>
            </div>
          </div>

          <div class="input" :class="{'required-error':!apiCallData.Tone.valid.required}">
            <div class="input-label">
              <span class="label">Tone</span>
              <div class="validation-required">(Required)</div>
            </div>
            <div class="input-wrap">
              <select v-model="apiCallData.Tone.value" @change="validate">
                <option value="" disabled style="display:none">- Select -</option>
                <option value="heartfelt">heartfelt</option>
                <option value="energetic">energetic</option>
                <option value="fun">fun</option>
              </select>
            </div>
          </div>

          <div class="input" :class="{'required-error':!apiCallData.photo1_8x9.valid.required}">
            <div class="input-label">
              <span class="label">Photo 1</span>
              <div class="validation-required">(Required)</div>
            </div>
            <div class="input-wrap">
              <input type="file" accept="image/*" @change="onFileChange($event, 'photo1_8x9')">
            </div>
          </div>

          <div class="input">
            <div class="input-label">
              <span class="label">Photo 2</span>
              <div class="validation-required">(Optional)</div>
            </div>
            <div class="input-wrap">
              <input type="file" accept="image/*" @change="onFileChange($event, 'photo2_8x9')">
            </div>
          </div>

          <div class="input">
            <div class="input-label">
              <span class="label">Photo 3</span>
              <div class="validation-required">(Optional)</div>
            </div>
            <div class="input-wrap">
              <input type="file" accept="image/*" @change="onFileChange($event, 'photo3_8x9')">
            </div>
          </div>

          <div class="input" :class="{'required-error':!apiCallData.narration.valid.required}">
            <div class="input-label">
              <span class="label">Do you want narration?</span>
              <div class="validation-required">(Required)</div>
            </div>
            <div class="input-wrap">
              <select v-model="apiCallData.narration.value" @change="validate">
                <option value="" disabled style="display:none">- Select -</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
          </div>

          <button class="submit-btn" :disabled="isGenerating" @click.prevent="generate">
            <span v-if="!isGenerating">Create Personalized Video</span>
            <span v-else class="spinner"></span>
          </button>

          <div v-if="apiErrors.length" class="error-box">
            <p v-for="(err, index) in apiErrors" :key="index">
              <strong>Error {{ err.error_code }}:</strong> {{ err.error_message }} - {{ err.error_description }}
            </p>
          </div>

        </div>
      </form>
    </div>
  </div>
</template>

<script>
import API from '@/api.js'

export default {
  name: 'FormView',
  data:()=>{
    return {
      apiCallData:{
        text_opening:{
          parameterName:'text_opening',
          value:'',
          maxLength:100,
          required:true,
          valid:{required:true, limit:true},
        },
        text_description:{
          parameterName:'text_description',
          value:'',
          maxLength:200,
          required:true,
          valid:{required:true, limit:true},
        },
        dollars_to_goal:{
          parameterName:'dollars_to_goal',
          value:'',
          required:true,
          valid:{required:true, limit:true},
        },
        percent_to_goal:{
          parameterName:'percent_to_goal',
          value:'',
          required:true,
          valid:{required:true, limit:true},
        },
        gfm_URL:{
          parameterName:'gfm_URL',
          value:'',
          required:true,
          valid:{required:true, limit:true},
        },
        Category:{
          parameterName:'Category',
          value:'',
          required:true,
          valid:{required:true, limit:true},
        },
        Tone:{
          parameterName:'Tone',
          value:'',
          required:true,
          valid:{required:true, limit:true},
        },
        photo1_8x9:{
          parameterName:'photo1_8x9',
          value:'',
          required:true,
          valid:{required:true, limit:true},
        },
        photo2_8x9:{
          parameterName:'photo2_8x9',
          value:'',
          required:false,
          valid:{required:true, limit:true},
        },
        photo3_8x9:{
          parameterName:'photo3_8x9',
          value:'',
          required:false,
          valid:{required:true, limit:true},
        },
        narration:{
          parameterName:'narration',
          value:'',
          required:true,
          valid:{required:true, limit:true},
        }
      },
      clickCount:0,
      apiErrors: [],
      isGenerating: false,
    }
  },

  methods:{
    onFileChange(event, key) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.apiCallData[key].value = e.target.result;
          this.validate();
        };
        reader.readAsDataURL(file);
      } else {
        this.apiCallData[key].value = '';
        this.validate();
      }
    },

    validate(){
      let valid = true

      for (const key in this.apiCallData) {
        this.apiCallData[key].valid.limit = true;
        if(this.apiCallData[key].maxLength && this.apiCallData[key].value.length > this.apiCallData[key].maxLength){
          this.apiCallData[key].valid.limit = false
          valid = false
        }
      }

      if(this.clickCount == 0){
        return valid
      }

      for (const key in this.apiCallData) {
        this.apiCallData[key].valid.required = true;
        if(this.apiCallData[key].required && this.apiCallData[key].value === ''){
          this.apiCallData[key].valid.required = false
          valid = false
        }
      }

      return valid
    },

    generate(){
      this.clickCount++
      this.apiErrors = []

      if(!this.validate()){
        return
      }

      this.isGenerating = true;

      console.log(`%cREQ:`, 'background:#2486dc;color:#222;font-weight:900;padding:3px 5px;border-radius:5px', this.apiCallData);
      API.generate({data:this.apiCallData})
      .then(data => {
        console.log(`%cRESP:`, 'background:#ccc;color:#222;font-weight:900;padding:3px 5px;border-radius:5px', data);
        this.$emit('generated',data)
      })
      .catch((e)=>{
        console.log(`%cRESP ERROR:`, 'background:#ccc;color:#222;font-weight:900;padding:3px 5px;border-radius:5px', e);
        this.apiErrors = Array.isArray(e) ? e : [{error_code: 'Unknown', error_message: 'Error', error_description: e.toString()}];
      })
      .finally(() => {
        this.isGenerating = false;
      })
    }
  },
}
</script>

<style scoped>

.main-title{
  max-width: 640px;
  margin: 15px auto 10px;
  text-align: center;
  padding: 0 10px;
}

.main-second-title{
  max-width: 640px;
  margin: 15px auto 30px;
  text-align: center;
  font-size: 18px;
  padding: 0 20px;
}

.error-box {
  background-color: #ffe6e6;
  border: 1px solid #ff4d4d;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 20px;
  color: #cc0000;
  margin:25px 0;
}
.error-box p {
  margin: 5px 0;
}

.form {
  max-width: 800px;
  padding: 20px 20px 50px;
  margin: 0 auto;
}

.form .input {
  display: flex;
  padding-bottom: 20px;
  align-items: center;
}

.form  .input-label {
  width: 35%;
  padding-right: 30px;
  box-sizing: border-box;
}

.form  .input-label span.label {
  font-size: 18px;
  display: block;
  font-weight: 500;
}

.form input, .form select {
  width: 100%;
  padding: 10px;
  height: 40px;
  box-sizing: border-box;
  font-size: 18px;
}

.form input:focus-visible, .form select:focus-visible, .form input:focus, .form .simple-typeahead input {
	outline: 0 !important;
	border: 1px solid  rgb(0, 111, 207);
}

.input-wrap{
  width: 65%;
}
.input-wrap .validation-format,
.input-wrap .validation-limit{
  display: none;
}

.format-error .input-wrap .validation-format,
.limit-error .input-wrap .validation-limit{
  display: inline-block;
}

.simple-typeahead >>> input{
  height: 40px;
  box-sizing: border-box;
  padding: 10px;
  font-size: 18px;
}

.simple-typeahead >>> input:focus {
	outline: 0 !important;
    border: 1px solid rgb(0, 111, 207);
}

.form input[type="checkbox"] {
  width: 20px;
  box-sizing: border-box;
}

.form input[type="submit"], .form button.submit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  width: 100%;
  background: #4a9d44;
  border: 1px solid transparent;
  font-weight: 400;
  max-width: 17.5rem;
  min-width: 11.25rem;
  transition: all 0.2s ease-in-out;
  vertical-align: middle;
  padding: 0 1.875rem;
  font-size: 1rem;
  line-height: 1.45667;
  border-radius: 0.25rem;
  margin: 0 auto;
  cursor: pointer;
  height: 45px;
}

.form input[type="submit"]:hover, .form button.submit-btn:hover {
  background-color: #3e8539;
}

.form button.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.spinner {
  border: 3px solid rgba(255, 255, 255, 0.3);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border-left-color: #fff;
  animation: spin 1s linear infinite;
  display: inline-block;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.required-error .validation-required{
  color:red;
}

.format-error select,
.format-error input,
.format-error >>> input,

.required-error select,
.required-error input,
.required-error >>> input,

.limit-error select,
.limit-error input,
.limit-error >>> input{
  border: 1px solid red;
}

.form-block {
	display: flex;
    align-items: flex-start;
    max-width: 1200px;
    margin: 0 auto;
}

.form-block img {
	max-width: 250px;
	padding-top: 20px;
    height: auto;
}

.form-block form {
	width: 100%;
}


@media (max-width: 767px) {
	.form .input-label span.label {
		font-size: 14px;
		
	}

	.form-block {
		flex-wrap: wrap;
	}

	.form-block form {
		width: 100%;
	}

	.form-block img {
		margin: 0 auto;
	}

	.player-info {
		padding-top: 25px;
	}

	.form .input-label {
		padding-right: 10px;
	}

	.form input, .form select {
		font-size: 14px;
	}

	.simple-typeahead >>> input{
		font-size: 14px;
	}

	.player-info a.btn-cfa {
		width: 100%;
	}
	.btn-back .btn-cfa {
		width: 100%;
	}
}




</style>
